// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Ol6G","alertIcon":"ConfirmModal_alertIcon__3q3ow"};